/** baby: Public org links used across /nin nav, footer, and CTAs */
export const NIN_GITHUB_URL = 'https://github.com/ninjapayofficial'
export const NIN_TWITTER_URL = 'https://x.com/Ninjapaydotme'
export const NIN_TELEGRAM_COMMUNITY_URL = 'https://t.me/+zxixB1S99rIzYWY1'
export const NIN_MCP_SERVER_URL = 'https://github.com/ninjapayofficial/nin-mcp-server'
/** baby: Self-hosted Connect platform dashboard and plugin registry */
export const NIN_CONNECT_PLATFORM_URL = 'https://connect.nin.in'
export const NIN_WEBUPI_DOCS_URL = 'https://ninjapay.gitbook.io/webupi-protocol'
export const NIN_LEARN_URL = '/cms/learn'
export const NIN_BLOGS_URL = '/cms/blogs'
/** baby: NINX landing download section */
export const NINXL_DOWNLOAD_HREF = '/ninxl#download'
/** baby: NINK tray voice-writing landing */
export const NINK_LANDING_HREF = '/nink'
export const NINK_DOWNLOAD_HREF = '/nink#download'
export const NINK_GITHUB_URL = 'https://github.com/ninworks/nink'
